import { Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import styles from "./deleteCertificate.module.scss";
import { ReactComponent as AlertIcon } from "../../../../assets/icons/alert.svg";

import i18next from "i18next";
import CheckboxGroup from "../../../../components/checkBoxGroupComponent/CheckboxGroup";
import Button from "../../../../components/buttons/Buttons";
import _ from "lodash";
import { getCertificatesList } from "../../../../services/APIService";
import { useApiErrorModalContext } from "../../../../errorHandling/ApiErrorModalContext";
import PropTypes from "prop-types";

const DeleteCertificate = (props) => {
  const { handleDelete, handleCancel } = props;
  const [certificateList, setCertificateList] = useState({});
  const [certificateOptions, setCertificateOptions] = useState([]);
  const [initialList, setInitialList] = useState([]);

  let isDeleteDisabled = Object.keys(_.pickBy(certificateList)).length === 0;
  const { setApiErrorModalState } = useApiErrorModalContext();
  useEffect(() => {
    getCertificatesList({})
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setCertificateOptions(response);
          let certificateNameList = response.map(
            (certificate) => certificate.key
          );
          setInitialList([...certificateNameList, "Combined certificates"]);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCheckBoxChange = (event) => {
    setCertificateList({
      ...certificateList,
      [event.target?.name]: event.target?.checked,
    });
  };
  return (
    <Box
      className={styles.deleteCertificateWrapper}
      data-testid="DeleteCertificate"
    >
      <Box className={styles.alertIcon}>
        <AlertIcon />
      </Box>
      <Box className={styles.description}>
        {i18next.t(
          "Please select the certificates below that you would like to delete for selected vehicles."
        )}
      </Box>
      <Box className={styles.checkBoxGroup}>
        <CheckboxGroup
          checkBoxList={initialList}
          name="certificateLable"
          handleChange={handleCheckBoxChange}
          checkBoxState={certificateList}
        />
      </Box>

      <Box className={styles.buttonWrapper}>
        <Button
          title="Don't delete"
          iconStyle={""}
          buttonType="muibtn-secondary"
          withIcon={false}
          handleClick={handleCancel}
        />
        <Button
          title="Yes, delete"
          iconStyle={""}
          buttonType="muibtn-primary"
          withIcon={false}
          isDisabled={isDeleteDisabled}
          handleClick={() => handleDelete(certificateList, certificateOptions)}
        />
      </Box>
    </Box>
  );
};
export default DeleteCertificate;
DeleteCertificate.propTypes = {
  handleDelete: PropTypes.any,
  handleCancel: PropTypes.any,
};
